import { IconOption } from "../types/iconOption";
import { icons } from "./icons";

export const OperationsIconOptions: IconOption[] = [
  {
    key: "BANK",
    name: "bank",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.BANK,
  },
  {
    key: "BOOK",
    name: "book",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.BOOK,
  },
  {
    key: "CART",
    name: "cart",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.CART,
  },
  {
    key: "CASH",
    name: "cash",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.CASH,
  },
  {
    key: "CEO",
    name: "CEO",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.CEO,
  },
  {
    key: "DEVELOPMENT",
    name: "development",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.DEVELOPMENT,
  },
  {
    key: "FINANCE",
    name: "finance",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.FINANCE,
  },

  {
    key: "HR",
    name: "HR",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.HR,
  },

  {
    key: "HR_1",
    name: "HR-1",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.HR_1,
  },

  {
    key: "KEYBOARD",
    name: "keyboard",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.KEYBOARD,
  },
  {
    key: "LABRATORY",
    name: "labratory",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.LABRATORY,
  },
  {
    key: "LAPTOP",
    name: "laptop",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.LAPTOP,
  },
  {
    key: "LOGISTIK",
    name: "logistik",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.LOGISTIK,
  },
  {
    key: "PROCESSES",
    name: "processes",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.PROCESSES,
  },
  {
    key: "R_D",
    name: "R&D",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.R_D,
  },
  {
    key: "SALES",
    name: "sales",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.SALES,
  },
  {
    key: "TEACHER",
    name: "tacher",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.TEACHER,
  },
  {
    key: "TRUCK",
    name: "truck",
    path: icons.PAGES.SETTINGS.ICON_OPTIONS.TRUCK,
  },
];
